<template>
 	<div class="calculator-border">
        <div class="calculator-display">
          <div class="calculator-formula"><span class="formula">Formula: {{ formula }}</span></div>
          <div class="calculator-result">{{ result }}</div>
        </div>
            
          <div class="calculator-items">
          <div class="calculator-row">
          <div class="calculator-item" @click="drop()">←</div>
          <div class="calculator-item" @click="cleanResult()">CE</div>
          <div class="calculator-item" @click="cleanAll()">AC</div>
          <div class="calculator-item" @click="operate('/')">/</div>
          
          <div class="calculator-item" @click="square()">√</div>
          </div>
                
           <div class="calculator-row">
          <div class="calculator-item" @click="operate(7)">7</div>
          <div class="calculator-item" @click="operate(8)">8</div>
          <div class="calculator-item" @click="operate(9)">9</div>
          <div class="calculator-item" @click="operate('*')">*</div>

          <div class="calculator-item" @click="operate('%')">%</div>
          </div>

          <div class="calculator-row">
          <div class="calculator-item" @click="operate(4)">4</div>
          <div class="calculator-item" @click="operate(5)">5</div>
          <div class="calculator-item" @click="operate(6)">6</div>
          <div class="calculator-item" @click="operate('-')">-</div>
          
          <div class="calculator-item" @click="devided()">1/x</div>
          </div>
                
          <div class="calculator-row">
          <div class="calculator-item" @click="operate(1)">1</div>
          <div class="calculator-item" @click="operate(2)">2</div>
          <div class="calculator-item" @click="operate(3)">3</div>
          <div class="calculator-item" @click="operate('+')">+</div>
          <div class="calculator-item" @click="toggle()">±</div>
          
          </div>
                
          <div class="calculator-row">
          <div class="calculator-item zero" @click="operate(0)">0</div>
          <div class="calculator-item" @click="operate('.')">.</div>
          <div class="calculator-item equal" @click="equal()">=</div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Calculator',
  data () {
    return {
     formula :"",
     result : 0 
    }
  },

  methods:{
    operate(element){
      console.log("operate..");
      this.formula +=element;
      // console.log("this.formula:");
      // console.log(this.formula);
    },

    equal(){
      console.log("equal..");
      this.result = eval(this.formula);
      // console.log("this.formula:");
      // console.log(this.formula);
    },

    cleanResult(){
      console.log("cleanResult..");
      this.result = 0;
    },

    cleanAll(){
      console.log("cleanAll..");
      this.formula = "";
      this.result = 0;
    },

    drop(){
        console.log("drop..");
        this.formula = this.formula.slice(0, -1);
    },

    square(){
        console.log("square..");
        console.log(eval(this.formula));
        eval(this.formula)<0? this.formula = "Cannot square the negative value" : this.result=Math.sqrt(eval(this.formula));
   },

   devided(){
        
        this.formula===""||this.formula.endsWith("+"||"-"||"*"||"/"||"%")? {} :  this.formula="1/("+this.formula+")";this.equal();
   },

   toggle(){
        console.log("toggle.."); 


        this.formula===""||this.formula.endsWith("+"||"-"||"*"||"/"||"%")? {} :  this.formula.startsWith("-")?this.formula = Math.abs(eval(this.formula)).toString(): this.formula="-("+this.formula+")";
        this.equal();
   }

 }
}
</script>

<style scoped>
/*vue*/
.calculator-border {
	margin-top: 20px;
	width: 100%;
	background-color: #262f3c;
	box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,0.6);
	padding: 10px;
	border-radius: 5px;
}

.calculator-display {
	background-color: #E6E6E6;
	padding: 20px 20px;
	
	border-radius: 5px;
}

.calculator-result {
	text-align: right;
	font-size: 1.6rem;
}

.calculator-items {
	/*background-color: white;*/
	padding: 0px;
	margin-top: 10px;
	border-radius: 10px;	
}

.calculator-row {
	display: flex;
}

.calculator-row .calculator-item {
	flex-basis: 20%;

padding: 13px;

background-color: #3C4450;

border-radius: 5px;
color: white;
margin: 7px;

text-align: center;
cursor: pointer;
box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,0.4);
/*font-weight: bold;*/
}


.calculator-item.zero {
	flex-basis: 40%;
}

.calculator-item.equal {
	flex-basis: 40%;
	background-color: #77bf43;
	color: white;
	
}


span.formula {
	color: #949494;
}

@media screen and (min-width: 1280px) {
	.calculator-border {
		width:400px;

	}
}

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/CalculatorComponent.vue